// extracted by mini-css-extract-plugin
export var active = "header-module--active--Z02Mw";
export var arrow = "header-module--arrow--LBMQi";
export var backArrow = "header-module--backArrow--ZT2RE";
export var catalogueContent = "header-module--catalogueContent--nNI1N";
export var catalogueCoursesInner = "header-module--catalogueCoursesInner--SBsom";
export var catalogueCoursesSection = "header-module--catalogueCoursesSection--gDRHM";
export var catalogueDropdownTitle = "header-module--catalogueDropdownTitle--YS-qa";
export var catalogueFacultySection = "header-module--catalogueFacultySection--b2L0K";
export var catalogueHeader = "header-module--catalogueHeader--Ly6Ax";
export var course = "header-module--course--zUCmH";
export var courseContent = "header-module--courseContent--RqibM";
export var courseImg = "header-module--courseImg--n3gXJ";
export var courseInfo = "header-module--courseInfo--Ht41d";
export var courseList = "header-module--courseList--E9+Ks";
export var courseRating = "header-module--courseRating--tTarH";
export var desktopLogo = "header-module--desktopLogo--rdSho";
export var dropdown = "header-module--dropdown--UprLg";
export var dropdownHeaderClose = "header-module--dropdownHeaderClose--TtYot";
export var dropdownTrigger = "header-module--dropdownTrigger--Ow4dZ";
export var enterpriseCta = "header-module--enterpriseCta--elvw0";
export var facultyCourseCount = "header-module--facultyCourseCount--i7vFk";
export var facultyHeader = "header-module--facultyHeader--WisIZ";
export var facultyIcon = "header-module--facultyIcon--7HgdR";
export var facultyLinkSection = "header-module--facultyLinkSection--B1YpS";
export var facultyName = "header-module--facultyName--t7DoP";
export var facultyNameSection = "header-module--facultyNameSection--NyOLU";
export var graduatesCount = "header-module--graduatesCount--7g4v8";
export var header = "header-module--header--hJ6Cd";
export var headerContent = "header-module--headerContent--YD4Sl";
export var headerLogo = "header-module--headerLogo--h-UyB";
export var headerScroll = "header-module--headerScroll--EE0Q6";
export var headerTopSection = "header-module--headerTopSection--bXFxe";
export var hideOnMobile = "header-module--hideOnMobile--ra9Or";
export var loginCta = "header-module--loginCta--ziGxb";
export var mobileLogo = "header-module--mobileLogo--Htlz0";
export var mobileSearch = "header-module--mobileSearch--aJ2+J";
export var shawBtn = "header-module--shawBtn--slu3a";
export var showLoginCtaOnMobile = "header-module--showLoginCtaOnMobile--zoqmF";
export var showOnMobile = "header-module--showOnMobile--vtAoa";
export var signUpCta = "header-module--signUpCta--Ew+OP";
export var spinnerBorder = "header-module--spinner-border--oWF99";
export var upskillBtn = "header-module--upskillBtn--zSrtm";
export var viewCatalogueCta = "header-module--viewCatalogueCta--3gCRK";